import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUser } from "../api/userApi";
import { toast } from "react-toastify";

export default function CreateUser() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "user",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await createUser(form);

      toast.success("User created successfully");

      setForm({
        name: "",
        email: "",
        password: "",
        role: "user",
      });

      // Go back to users list after successful creation
      setTimeout(() => {
        navigate("/users");
      }, 1000);
    } catch (err) {
      console.error("CREATE USER ERROR:", err);

      toast.error(
        err.response?.data?.message ||
          "User creation failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      {/* ================= HEADER ================= */}

      <div className="mb-5">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
          Create New User
        </h1>

        <p className="text-sm text-gray-500 mt-1">
          Create a new user or administrator account.
        </p>
      </div>

      {/* ================= FORM CARD ================= */}

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6">
        <form
          onSubmit={handleSubmit}
          className="space-y-5"
        >
          {/* NAME */}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Full Name
            </label>

            <input
              name="name"
              type="text"
              placeholder="Enter full name"
              value={form.name}
              onChange={handleChange}
              required
              disabled={loading}
              className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                disabled:bg-gray-100 disabled:cursor-not-allowed"
            />
          </div>

          {/* EMAIL */}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Email Address
            </label>

            <input
              name="email"
              type="email"
              placeholder="Enter email address"
              value={form.email}
              onChange={handleChange}
              required
              disabled={loading}
              className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                disabled:bg-gray-100 disabled:cursor-not-allowed"
            />
          </div>

          {/* PASSWORD */}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Password
            </label>

            <input
              name="password"
              type="password"
              placeholder="Enter password"
              value={form.password}
              onChange={handleChange}
              required
              disabled={loading}
              className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                disabled:bg-gray-100 disabled:cursor-not-allowed"
            />

            <p className="text-xs text-gray-500 mt-1.5">
              Use a strong password for the account.
            </p>
          </div>

          {/* ROLE */}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              User Role
            </label>

            <select
              name="role"
              value={form.role}
              onChange={handleChange}
              disabled={loading}
              className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm bg-white
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="user">
                User
              </option>

              <option value="admin">
                Admin
              </option>
            </select>
          </div>

          {/* ================= ACTIONS ================= */}

          <div className="flex flex-col-reverse sm:flex-row gap-3 pt-3 border-t border-gray-100">
            <button
              type="button"
              onClick={() => navigate("/users")}
              disabled={loading}
              className="w-full sm:w-auto px-5 py-2.5 border border-gray-300
                text-gray-700 rounded-lg text-sm font-medium
                hover:bg-gray-50
                disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="w-full sm:flex-1 px-5 py-2.5
                bg-blue-600 hover:bg-blue-700
                text-white rounded-lg text-sm font-medium
                disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading
                ? "Creating..."
                : "Create User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}